// ⚠️  MOBILE-FIRST. Daily community challenge — same exercise for everyone.
// variant="strip": one-line card for the Dashboard. variant="board": compact
// top-3 board for the Compete page. Stale-while-revalidate: yesterday's cache
// is ignored (date-checked) so the exercise never shows wrong.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swords, Play, ChevronRight } from "lucide-react";
import { dailyChallenge } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { readCache, writeCache } from "../lib/swr-cache";

function localToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function DailyChallengeCard({ variant = "strip" }) {
    const { user } = useAuth();
    const cacheKey = `daily_${user?.user_id || "anon"}`;
    const [daily, setDaily] = useState(() => {
        const cached = readCache(cacheKey);
        return cached && cached.date === localToday() ? cached : null;
    });
    const navigate = useNavigate();

    useEffect(() => {
        dailyChallenge()
            .then((r) => {
                setDaily(r.data);
                writeCache(cacheKey, r.data);
            })
            .catch((err) => console.warn("[daily] fetch failed:", err?.message || err));
    }, [cacheKey]);

    if (!daily?.exercise) return null;
    const ex = daily.exercise;
    const unit = ex.metric === "hold" ? "s" : " reps";
    const go = () => navigate(`/workout/${ex.exercise_id}`);

    if (variant === "strip") {
        return (
            <button type="button" className="daily-strip" onClick={go} data-testid="daily-challenge-strip">
                <span className="ic"><Swords size={18} /></span>
                <span className="mid">
                    <b>Daily challenge - {ex.name}</b>
                    <span>
                        {daily.participants} in today
                        {daily.my_best != null ? ` - your best ${daily.my_best}${unit}` : " - you're not on the board yet"}
                    </span>
                </span>
                <Play size={16} className="go" />
            </button>
        );
    }

    return (
        <div className="daily-board" data-testid="daily-challenge-board">
            <div className="db-head">
                <span className="lab"><Swords size={13} /> Daily challenge</span>
                <span className="ex">{ex.name.toUpperCase()}</span>
            </div>
            {daily.leaders.length === 0 ? (
                <div className="db-empty">No one's on today's board yet. First set wins it.</div>
            ) : (
                daily.leaders.slice(0, 3).map((l, i) => (
                    <div className="db-row" key={l.user_id}>
                        <span className={`rk ${i === 0 ? "gold" : ""}`}>{i + 1}</span>
                        {l.picture ? <img className="av" src={l.picture} alt="" /> : <span className="av">{l.name?.[0] || "U"}</span>}
                        <span className="nm">{l.name}</span>
                        <span className="sc">{l.best}{unit}</span>
                    </div>
                ))
            )}
            <button type="button" className="db-cta" onClick={go} data-testid="daily-board-go">
                {daily.my_rank ? `You're #${daily.my_rank} - improve your best` : "Post your score"} <ChevronRight size={15} />
            </button>
        </div>
    );
}
